module.exports = __webpack_public_path__ + "img/志愿者风采.5f3ddecb.jpg";